






import { Component, Prop, Vue } from "vue-property-decorator";

@Component
export default class ActionButton extends Vue {
    @Prop() private src!: string;
    @Prop() private width!: string;
    @Prop() private onClick?: () => void;

    private handleClickButton = () => {
        if ( this.onClick ) {
            this.onClick();
        }
    }
}
